import React from 'react';
import { AdminFactoryV3 } from './factory_v3/AdminFactoryV3';

/**
 * MIGRATION SWITCHER
 * 
 * This file replaces the old AdminFactory.
 * It currently points directly to V3.
 * 
 * Failure Safety:
 * If V3 is broken, change the import above to:
 * import { AdminFactory } from './AdminFactoryV2_Legacy';
 */

export const AdminFactory = () => {
    return <AdminFactoryV3 />;
};
